import { Column } from 'src/shared/components/Semantic/all'
import { IconImage } from 'src/pages/Home/components/IconImage'
import { Button } from 'src/shared/components/ui/button'
import { cn } from 'src/shared/components/ui/utils'
import { Trash2 } from 'lucide-react'

export const LogoGrid = ({
  uploadedLogos,
  brandfetchUrls,
  selectedDesignUrl,
  onSelectDesignUrl,
  onDeleteLogo,
}) => {
  return (
    <div className="grid grid-cols-2 gap-2 h-[145px] overflow-y-auto border border-gray-200 rounded-lg p-2 bg-white">
      {uploadedLogos.map((logo, index) => (
        <Column
          key={`uploaded-${logo.url}-${index}`}
          className="relative group h-full"
        >
          <IconImage
            src={logo.url}
            selected={selectedDesignUrl === logo.url}
            onClick={() => onSelectDesignUrl(logo.url)}
            className={cn('cursor-pointer h-[60px] w-full')}
          />
          <Button
            variant="destructive"
            size="sm"
            className="absolute top-1 right-1 opacity-0 group-hover:opacity-100 transition-opacity p-1 h-6 w-6"
            onClick={(e) => {
              e.stopPropagation()
              onDeleteLogo(logo)
            }}
          >
            <Trash2 className="w-3 h-3" />
          </Button>
        </Column>
      ))}

      {brandfetchUrls.map((url, index) => (
        <Column key={`brandfetch-${url}-${index}`} className="h-full">
          <IconImage
            src={url}
            selected={selectedDesignUrl === url}
            onClick={() => onSelectDesignUrl(url)}
            className={cn('cursor-pointer h-[60px] w-full')}
          />
        </Column>
      ))}
    </div>
  )
}
